import routes from "./routes";
import AuthService from "./Service";

export {
  routes,
  AuthService
};
